import './styles.css';
import React from 'react';


function Badge({ className, line1, line2, line3, line4 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 400 400"
      width="100%"
      height="100%"
      className={`RadialBadge_10 Badge ${className}`}
    >

      {/* ------------------------------------------ */}

      <defs>
        <path
          id="RadialBadge_10__TopCircle"
          d="M 35 200 A 50 50 0 0 1 365 200"
        />

        <path
          id="RadialBadge_10__BottomCircle"
          d="M 35 200 A 50 50 0 0 0 365 200"
        />
      </defs>

      {/* ------------------------------------------ */}

      <g>
        <circle cx="200" cy="200" r="200" className="Badge__FirstFillColor" />
        <g>
          <path
            d="M200,337.47C124.2,337.47,62.53,275.8,62.53,200S124.2,62.53,200,62.53,337.46,124.2,337.46,200,275.8,337.47,200,337.47Zm0-270.25C126.78,67.22,67.22,126.78,67.22,200S126.78,332.78,200,332.78,332.78,273.22,332.78,200,273.21,67.22,200,67.22Z"
            className="Badge__SecondFillColor"
          />
          <g>
            <g>
              <path
                d="M219,327.84c-6.36-.46-12.7-.69-18.95-.69s-12.59.23-18.85.69l-.1-1.17,0-1.17c6.23-.46,12.62-.7,18.93-.7s12.7.24,19,.7a1.19,1.19,0,0,1,1.1,1.21A1.16,1.16,0,0,1,219,327.84Z"
                className="Badge__SecondFillColor"
              />
              <path
                d="M157.45,322a1.18,1.18,0,0,1-1.15-1,1.16,1.16,0,0,1,1-1.34,264.64,264.64,0,0,1,85.46,0,1.17,1.17,0,1,1-.38,2.31,262.78,262.78,0,0,0-84.7,0Z"
                className="Badge__SecondFillColor"
              />
              <path
                d="M256.62,316.06a1.06,1.06,0,0,1-.31,0,262.19,262.19,0,0,0-112.67,0,1.19,1.19,0,0,1-1.4-.89,1.18,1.18,0,0,1,.89-1.4,264.59,264.59,0,0,1,113.67,0l.15,0,.25.05.15.15a1.18,1.18,0,0,1-.28,2A1.2,1.2,0,0,1,256.62,316.06Z"
                className="Badge__SecondFillColor"
              />
              <path
                d="M267.41,310.07a1,1,0,0,1-.3,0,260.58,260.58,0,0,0-134.22,0,1.17,1.17,0,0,1-.6-2.26,262.87,262.87,0,0,1,135.42,0,1.17,1.17,0,0,1-.3,2.3Z"
                className="Badge__SecondFillColor"
              />
              <path
                d="M276.35,304a1.06,1.06,0,0,1-.35-.05,260.16,260.16,0,0,0-152,0,1.17,1.17,0,0,1-.68-2.24,262.55,262.55,0,0,1,153.38,0,1.17,1.17,0,0,1-.34,2.29Z"
                className="Badge__SecondFillColor"
              />
              <path
                d="M284,297.83a1.21,1.21,0,0,1-.38-.06,259.95,259.95,0,0,0-167.26,0,1.17,1.17,0,0,1-.76-2.22,262.38,262.38,0,0,1,168.77,0,1.17,1.17,0,0,1-.37,2.28Z"
                className="Badge__SecondFillColor"
              />
              <path
                d="M109.3,291.59a1.17,1.17,0,0,1-.41-2.27,262,262,0,0,1,182.21,0,1.17,1.17,0,1,1-.82,2.19,259.84,259.84,0,0,0-180.57,0A1.15,1.15,0,0,1,109.3,291.59Z"
                className="Badge__SecondFillColor"
              />
              <path
                d="M296.61,285.23a1.15,1.15,0,0,1-.44-.09,259.63,259.63,0,0,0-192.35,0A1.17,1.17,0,0,1,103,283a262,262,0,0,1,194.1,0,1.17,1.17,0,0,1,.65,1.52A1.19,1.19,0,0,1,296.61,285.23Z"
                className="Badge__SecondFillColor"
              />
              <path
                d="M98.12,278.76a1.17,1.17,0,0,1-.46-2.25,262.05,262.05,0,0,1,204.68,0,1.17,1.17,0,1,1-.92,2.16,259.61,259.61,0,0,0-202.84,0A1.25,1.25,0,0,1,98.12,278.76Z"
                className="Badge__SecondFillColor"
              />
              <path
                d="M306.58,272.19a1.15,1.15,0,0,1-.48-.1,259.41,259.41,0,0,0-212.2,0,1.17,1.17,0,0,1-1-2.14,261.71,261.71,0,0,1,214.12,0,1.17,1.17,0,0,1-.48,2.24Z"
                className="Badge__SecondFillColor"
              />
              <path
                d="M89.23,265.48a1.18,1.18,0,0,1-1.06-.67,1.16,1.16,0,0,1,.56-1.56,261.71,261.71,0,0,1,222.53,0,1.18,1.18,0,0,1,.56,1.56,1.17,1.17,0,0,1-1.56.56,259.33,259.33,0,0,0-220.53,0A1.33,1.33,0,0,1,89.23,265.48Z"
                className="Badge__SecondFillColor"
              />
              <path
                d="M85.8,258.64h-.28a1.17,1.17,0,0,1-.42-2.27,261.61,261.61,0,0,1,229.89,0,1.17,1.17,0,0,1-1,2.11,259.21,259.21,0,0,0-227.92,0Z"
                className="Badge__SecondFillColor"
              />
            </g>
            <path
              d="M74.68,227.69a1.18,1.18,0,0,1-1.15-.93,129.24,129.24,0,1,1,252.92,0,1.17,1.17,0,1,1-2.29-.48,126.89,126.89,0,1,0-248.34,0,1.17,1.17,0,0,1-.9,1.39Z"
              className="Badge__SecondFillColor"
            />
          </g>
          <g>
            <g>
              <path
                d="M321.31,105.72a1.08,1.08,0,0,1-1.5-.3c-10.44-13.33-22.73-23.62-36.35-33.49a1,1,0,1,1,1.1-1.67,205.36,205.36,0,0,1,36.82,33.92A1.08,1.08,0,0,1,321.31,105.72Z"
                className="Badge__SecondFillColor"
              />
              <path
                d="M315.57,90.46a1.13,1.13,0,0,1-1.56-.2,160.17,160.17,0,0,0-27.49-23,1,1,0,1,1,1.1-1.67,162.55,162.55,0,0,1,27.84,23.24A1.13,1.13,0,0,1,315.57,90.46Z"
                className="Badge__SecondFillColor"
              />
              <path
                d="M330.08,135.12l1.48-.35c.43-.1,1.93-.45,3.92-.8-4.25-2.74-11.72-11.4-12.66-12.41l-1.14-1.22,1.43-.52a66.82,66.82,0,0,1,9-2.54,15,15,0,0,1-5.71-5c-3.66-5.31-7.79-24.53-8-25.35l-.5-1.74,1.72.58c.81.3,20.09,8.47,24.24,14.51a15.43,15.43,0,0,1,2.79,8c2.51-3.55,5.39-6.88,5.91-7.48l1-1.17c.35.76.52,1.14.85,1.9.71,1.58,5.79,14.8,5.64,20.54,1.47-1.43,2.62-2.49,2.95-2.79l1.15-1c.25.79.37,1.19.61,2,.52,1.64,4,15.3,3.19,21,1.62-1.25,2.9-2.17,3.26-2.43s.76-.53,1.26-.9c.16.81.24,1.22.38,2,.32,1.67,2.22,15.59.76,21.12,1.75-1.06,3.12-1.82,3.51-2l1.35-.74c.07.82.09,1.23.15,2,.12,1.7.42,15.73-1.66,21.06,1.87-.85,3.3-1.45,3.72-1.62l1.43-.59c0,.82-.05,1.23-.09,2.06-.07,1.7-1.38,15.73-4.07,20.79,1.95-.63,3.46-1.07,3.89-1.19l1.49-.42c-.13.82-.19,1.23-.32,2-.27,1.68-3.18,15.52-6.43,20.28,2-.41,3.55-.67,4-.74l1.53-.25c-.22.8-.33,1.2-.56,2-.5,1.8-5.87,17.34-9.66,20.44a7.08,7.08,0,0,1-6.39,1.61,7.41,7.41,0,0,1-4.67-4.24.75.75,0,0,1-.1-.2.9.9,0,0,1-.08-.21,5.36,5.36,0,0,1-.25-.62,219.36,219.36,0,0,1-21.27,49.37,1,1,0,1,1-1.68-1.07,217,217,0,0,0,21-48.78c-.17.15-.33.29-.51.42l-.17.15-.19.12a7.11,7.11,0,0,1-6.12,1.23,7.78,7.78,0,0,1-4.85-4.18c-2-4-2.13-17.31-2.21-18.8,0-.67-.06-1-.11-1.66l1.44.51c.41.15,1.87.68,3.72,1.47-2.07-4.64-3.65-16-3.88-17.3l-.3-1.62,1.48.34c.43.1,1.94.46,3.88,1-2.6-4.34-5.46-15.34-5.85-16.66l-.48-1.57,1.51.16c.44,0,2,.24,4,.58-3.07-4-7.17-14.57-7.7-15.83-.26-.61-.39-.91-.66-1.51H343c.45,0,2,0,4,.12-3.51-3.62-8.78-13.67-9.46-14.85-.32-.57-.49-.86-.82-1.43l1.51-.18c.44,0,2-.23,4-.35-3.91-3.18-10.31-12.6-11.12-13.71Zm-4.67-13.74c3.25,3.44,9,10,11.61,11.05a5.83,5.83,0,0,0,4.82,0,5.32,5.32,0,0,0,2.63-2.79c-2.78-1.27-4.17-1.86-7-3a1.32,1.32,0,0,1-.78-1.46.88.88,0,0,1,1.23-.67c2.81,1.09,4.22,1.68,7,2.94a8.35,8.35,0,0,0-5.1-8.2C337.15,118.26,329.48,120.09,325.41,121.38Zm16.82-20c-2.76-4-14.9-10.45-21.15-12.85,1.83,6.44,4.52,19,7,22.58,2.94,4.28,8,6.23,11.94,4.56-2.69-4.5-4.13-6.71-7.19-11a1,1,0,1,1,1.63-1.16c3.09,4.35,4.55,6.59,7.27,11.15C345.08,112,345.49,106.15,342.23,101.41ZM353.31,104c-2.83,3.28-7.9,9.4-8.35,12.35a9.64,9.64,0,0,0,4.11,9.07c.66-3,1-4.6,1.47-7.74a.85.85,0,0,1,1.24-.67,1.59,1.59,0,0,1,.87,1.62c-.54,3.16-.85,4.71-1.53,7.77,2,.33,3,.2,3.85-.21a5.4,5.4,0,0,0,2.9-4C358.45,119.21,355.49,109.33,353.31,104Zm10.07,18.53c-3.2,2.93-8.94,8.41-9.74,11.28a9.11,9.11,0,0,0,.38,5.69,9.33,9.33,0,0,0,2.64,3.75c1-2.95,1.49-4.45,2.37-7.49a.84.84,0,0,1,1.3-.53A1.55,1.55,0,0,1,361,137c-.9,3.06-1.38,4.56-2.42,7.51,2,.56,2.95.54,3.85.23a5.36,5.36,0,0,0,3.34-3.62C366.71,138.15,364.92,128.05,363.38,122.56ZM371.21,142c-3.52,2.54-9.87,7.31-11,10.06a9.43,9.43,0,0,0,1.92,9.69c1.34-2.8,2-4.23,3.2-7.15a.85.85,0,0,1,1.36-.37,1.54,1.54,0,0,1,.47,1.75c-1.24,2.93-1.9,4.37-3.27,7.19,1.9.76,2.87.85,3.8.65a5.43,5.43,0,0,0,3.74-3.21C372.72,157.85,372.09,147.64,371.21,142Zm5.52,20.18c-3.78,2.12-10.63,6.12-12.05,8.73a9.49,9.49,0,0,0,.8,9.85c1.65-2.63,2.45-4,4-6.74a.85.85,0,0,1,1.39-.22,1.58,1.58,0,0,1,.27,1.81c-1.57,2.77-2.39,4.12-4.07,6.76,1.81,1,2.75,1.19,3.71,1.1a5.4,5.4,0,0,0,4.07-2.78C376.42,178.1,377,167.89,376.73,162.21Zm3.2,20.68c-4,1.68-11.26,4.88-13,7.31a9,9,0,0,0-1.55,5.47,9.15,9.15,0,0,0,1.22,4.43c1.94-2.43,2.89-3.68,4.75-6.25a.86.86,0,0,1,1.41-.06,1.59,1.59,0,0,1,.06,1.83c-1.88,2.57-2.85,3.82-4.82,6.26a5.28,5.28,0,0,0,3.55,1.52,5.37,5.37,0,0,0,4.37-2.29C377.81,198.67,379.52,188.56,379.93,182.89Zm.8,21c-4.17,1.2-11.74,3.55-13.73,5.77a9.21,9.21,0,0,0-2.18,5.29,9.3,9.3,0,0,0,.7,4.57c2.22-2.21,3.31-3.35,5.45-5.7a.84.84,0,0,1,1.4.11,1.6,1.6,0,0,1-.15,1.84c-2.17,2.35-3.27,3.49-5.51,5.7a5.12,5.12,0,0,0,8,.13C376.81,219.36,379.67,209.46,380.73,203.87ZM362.15,238.8c2.46-2,3.68-3,6.08-5.09a.83.83,0,0,1,1.38.28,1.59,1.59,0,0,1-.36,1.81c-2.43,2.11-3.66,3.12-6.15,5.07a5.2,5.2,0,0,0,3.09,2.33A5.39,5.39,0,0,0,371,242c2.39-2,6.41-11.57,8.11-17.06-4.28.72-12.1,2.21-14.31,4.2a9.21,9.21,0,0,0-2.79,5A9.39,9.39,0,0,0,362.15,238.8Zm-15.61-18.36c.31,4.73.58,13.5,1.87,16a5.85,5.85,0,0,0,3.71,3.11,5.25,5.25,0,0,0,3.8-.49c-1.32-2.79-2-4.15-3.44-6.8a1.36,1.36,0,0,1,.33-1.64.88.88,0,0,1,1.38.28c1.46,2.66,2.16,4,3.51,6.81a8.57,8.57,0,0,0,1.33-9.67C357.59,225.54,350.5,222.05,346.54,220.44Zm1.34-17.23c.86,4.61,2.15,13.22,3.73,15.57a5.84,5.84,0,0,0,4,2.64,5.34,5.34,0,0,0,3.73-.9c-1.64-2.59-2.49-3.85-4.22-6.3a1.34,1.34,0,0,1,.13-1.66.89.89,0,0,1,1.4.11c1.77,2.45,2.63,3.71,4.29,6.3a8.39,8.39,0,0,0,.18-9.65C359.43,207,352,204.34,347.88,203.21ZM347.22,186c1.38,4.48,3.65,12.83,5.5,15a5.88,5.88,0,0,0,4.32,2.14,5.29,5.29,0,0,0,3.59-1.33c-1.92-2.37-2.91-3.51-4.92-5.73a1.32,1.32,0,0,1,0-1.65.9.9,0,0,1,1.4,0c2,2.22,3,3.37,5,5.73a8.31,8.31,0,0,0-.93-9.56C359.13,188.41,351.44,186.68,347.22,186Zm-2.62-17c1.88,4.28,5.11,12.3,7.18,14.2a5.83,5.83,0,0,0,4.53,1.63,5.25,5.25,0,0,0,3.42-1.73c-2.19-2.12-3.3-3.14-5.55-5.11a1.34,1.34,0,0,1-.24-1.63.9.9,0,0,1,1.39-.22c2.27,2,3.4,3,5.61,5.11a8,8,0,0,0,.58-4.45,7.87,7.87,0,0,0-2.6-4.92C356.71,170.07,348.87,169.23,344.6,169.07Zm-4.53-16.54c2.36,4,6.47,11.64,8.75,13.29a5.88,5.88,0,0,0,4.69,1.09,5.41,5.41,0,0,0,3.2-2.1c-2.41-1.86-3.64-2.75-6.1-4.45a1.32,1.32,0,0,1-.42-1.59.9.9,0,0,1,1.36-.37c2.48,1.7,3.71,2.58,6.14,4.43a8.24,8.24,0,0,0-3.07-9.07C352.21,152.14,344.33,152.2,340.07,152.53Zm3.82-3.72a5.87,5.87,0,0,0,4.78.55,5.27,5.27,0,0,0,2.93-2.46c-2.6-1.57-3.92-2.32-6.55-3.73a1.3,1.3,0,0,1-.61-1.52.89.89,0,0,1,1.3-.53c2.67,1.4,4,2.15,6.62,3.71a8,8,0,0,0-.44-4.48,7.9,7.9,0,0,0-3.65-4.21c-2.59-1.33-10.42-.38-14.61.43C336.48,140.34,341.43,147.43,343.89,148.81Z"
                className="Badge__SecondFillColor"
              />
              <path
                d="M314.62,81.87A1.16,1.16,0,0,1,313,81.7a137.38,137.38,0,0,0-23.56-18.84,1,1,0,1,1,1.11-1.67A139.76,139.76,0,0,1,314.4,80.27,1.16,1.16,0,0,1,314.62,81.87Z"
                className="Badge__SecondFillColor"
              />
              <path
                d="M323.34,83.16a1.18,1.18,0,0,1-1.61-.26,255.39,255.39,0,0,0-29.34-24.49,1,1,0,1,1,1.1-1.66,256.5,256.5,0,0,1,29.68,24.77A1.17,1.17,0,0,1,323.34,83.16Z"
                className="Badge__SecondFillColor"
              />
              <path
                d="M338.54,92.45a1.2,1.2,0,0,1-1.61-.44,176,176,0,0,0-41.49-38.22,1.05,1.05,0,1,1,1.1-1.66,177.55,177.55,0,0,1,42,38.65A1.21,1.21,0,0,1,338.54,92.45Z"
                className="Badge__SecondFillColor"
              />
            </g>
            <g>
              <path
                d="M77.45,103.69a1.09,1.09,0,0,0,1.5-.31c10.43-13.32,22.73-23.61,36.35-33.49a1,1,0,1,0-1.1-1.66,205,205,0,0,0-36.82,33.92A1.07,1.07,0,0,0,77.45,103.69Z"
                className="Badge__SecondFillColor"
              />
              <path
                d="M83.18,88.42a1.12,1.12,0,0,0,1.57-.2,160.17,160.17,0,0,1,27.49-23,1,1,0,1,0-1.1-1.66A161.26,161.26,0,0,0,83.3,86.85,1.12,1.12,0,0,0,83.18,88.42Z"
                className="Badge__SecondFillColor"
              />
              <path
                d="M68.68,133.09l-1.49-.35c-.42-.11-1.92-.45-3.91-.8,4.25-2.75,11.72-11.4,12.66-12.42.45-.49.68-.73,1.14-1.21l-1.43-.52a65.13,65.13,0,0,0-9.05-2.54,15.11,15.11,0,0,0,5.72-5c3.65-5.31,7.79-24.53,8-25.36l.5-1.74-1.72.59C78.31,84,59,92.2,54.88,98.24a15.48,15.48,0,0,0-2.78,8c-2.51-3.55-5.39-6.89-5.92-7.49l-1-1.17c-.35.76-.52,1.15-.85,1.91-.71,1.58-5.8,14.79-5.65,20.54-1.46-1.44-2.61-2.49-2.94-2.79l-1.15-1c-.25.79-.38,1.18-.62,2-.51,1.64-4,15.31-3.18,21-1.63-1.26-2.9-2.17-3.27-2.43l-1.25-.9c-.16.81-.24,1.21-.39,2-.31,1.67-2.21,15.6-.75,21.13-1.76-1.06-3.12-1.82-3.51-2l-1.35-.75c-.07.82-.09,1.23-.15,2.05-.12,1.71-.42,15.74,1.66,21.07-1.87-.85-3.31-1.45-3.72-1.62l-1.43-.59c0,.82.05,1.23.09,2,.07,1.71,1.37,15.74,4.07,20.8-2-.64-3.46-1.07-3.89-1.19l-1.49-.42c.12.81.19,1.22.32,2,.27,1.68,3.18,15.51,6.43,20.27-2-.4-3.55-.66-4-.73l-1.53-.25c.22.8.33,1.2.56,2,.5,1.8,5.87,17.34,9.66,20.44a7.05,7.05,0,0,0,6.38,1.61,7.4,7.4,0,0,0,4.67-4.25.68.68,0,0,0,.11-.19,1,1,0,0,0,.08-.22,4.19,4.19,0,0,0,.24-.62A220.54,220.54,0,0,0,59.6,287.8a1,1,0,1,0,1.69-1.08,216.81,216.81,0,0,1-21-48.78,5.5,5.5,0,0,0,.51.43,1.27,1.27,0,0,0,.17.14.84.84,0,0,0,.19.12,7.13,7.13,0,0,0,6.12,1.24,7.79,7.79,0,0,0,4.85-4.19c2-4,2.13-17.31,2.21-18.8,0-.66.06-1,.11-1.66l-1.44.51c-.41.15-1.87.68-3.72,1.48,2.07-4.65,3.65-16,3.88-17.3l.3-1.62-1.49.34c-.43.1-1.93.45-3.88,1,2.61-4.34,5.47-15.35,5.86-16.66.19-.63.28-.95.48-1.58l-1.51.17c-.44,0-2,.23-4,.57,3.07-4,7.16-14.57,7.7-15.83.26-.6.39-.9.66-1.5H55.78c-.44,0-2,0-4,.11,3.51-3.62,8.78-13.66,9.45-14.85l.83-1.42-1.51-.18c-.44,0-2-.23-4-.35,3.91-3.19,10.32-12.6,11.13-13.71C68.08,133.88,68.28,133.62,68.68,133.09Zm4.67-13.74c-3.25,3.43-9,10-11.61,11a5.83,5.83,0,0,1-4.82,0,5.23,5.23,0,0,1-2.63-2.78c2.77-1.27,4.17-1.87,7-3a1.35,1.35,0,0,0,.78-1.47.9.9,0,0,0-1.24-.67c-2.81,1.1-4.21,1.69-7,2.94a8.08,8.08,0,0,1,1-4.41,8,8,0,0,1,4.13-3.78C61.61,116.22,69.27,118.06,73.35,119.35Zm-16.82-20c2.76-4,14.9-10.45,21.14-12.84-1.82,6.43-4.51,19-7,22.58-2.94,4.27-8,6.23-11.93,4.56,2.69-4.51,4.13-6.71,7.19-11a1,1,0,1,0-1.63-1.16c-3.1,4.35-4.55,6.59-7.27,11.14C53.68,109.93,53.27,104.11,56.53,99.37ZM45.44,102c2.84,3.29,7.91,9.4,8.36,12.36a9.62,9.62,0,0,1-4.12,9.07c-.66-3-1-4.6-1.47-7.74A.84.84,0,0,0,47,115a1.57,1.57,0,0,0-.87,1.62c.54,3.15.84,4.71,1.53,7.77-2,.33-3,.19-3.86-.22a5.39,5.39,0,0,1-2.89-4C40.3,117.18,43.27,107.29,45.44,102ZM35.38,120.52c3.2,2.93,8.94,8.42,9.73,11.29a9,9,0,0,1-.38,5.68,9.17,9.17,0,0,1-2.64,3.75c-1-2.94-1.48-4.44-2.36-7.49a.84.84,0,0,0-1.31-.52,1.55,1.55,0,0,0-.67,1.69c.91,3.06,1.39,4.56,2.43,7.51-2,.56-3,.54-3.86.23A5.42,5.42,0,0,1,33,139C32,136.11,33.84,126,35.38,120.52ZM27.55,140c3.52,2.54,9.86,7.3,11,10.05a9.52,9.52,0,0,1-1.92,9.7c-1.34-2.8-2-4.23-3.21-7.15a.84.84,0,0,0-1.35-.38,1.55,1.55,0,0,0-.47,1.76c1.24,2.93,1.9,4.37,3.26,7.18-1.9.77-2.86.86-3.8.66a5.41,5.41,0,0,1-3.73-3.22C26,155.81,26.67,145.6,27.55,140ZM22,160.18c3.79,2.12,10.63,6.12,12.06,8.72a9,9,0,0,1,.92,5.61,9.18,9.18,0,0,1-1.72,4.25c-1.66-2.64-2.46-4-4-6.75a.85.85,0,0,0-1.39-.21,1.55,1.55,0,0,0-.27,1.81c1.57,2.76,2.38,4.12,4.06,6.75-1.8,1-2.75,1.2-3.7,1.1a5.39,5.39,0,0,1-4.08-2.78C22.34,176.07,21.78,165.85,22,160.18Zm-3.19,20.68c4,1.68,11.26,4.88,13,7.31a9,9,0,0,1,1.56,5.47,9.18,9.18,0,0,1-1.22,4.43c-1.94-2.44-2.9-3.69-4.75-6.26a.85.85,0,0,0-1.41-.05,1.56,1.56,0,0,0-.06,1.82c1.88,2.57,2.85,3.83,4.82,6.26a5.12,5.12,0,0,1-7.92-.76C21,196.64,19.24,186.53,18.83,180.86Zm-.8,21c4.16,1.2,11.74,3.55,13.72,5.78a9.15,9.15,0,0,1,2.19,5.29,9.27,9.27,0,0,1-.71,4.56c-2.21-2.2-3.3-3.34-5.44-5.7a.84.84,0,0,0-1.4.12,1.58,1.58,0,0,0,.15,1.83c2.16,2.35,3.27,3.49,5.51,5.7a5.3,5.3,0,0,1-3.35,1.92,5.38,5.38,0,0,1-4.61-1.78C22,217.33,19.08,207.43,18,201.83Zm18.58,34.93c-2.47-2-3.68-3-6.09-5.08a.83.83,0,0,0-1.38.27,1.61,1.61,0,0,0,.37,1.82c2.43,2.1,3.66,3.12,6.15,5.07a5.26,5.26,0,0,1-3.1,2.33,5.37,5.37,0,0,1-4.79-1.26c-2.39-2-6.41-11.57-8.12-17,4.28.72,12.11,2.2,14.32,4.19a9.3,9.3,0,0,1,2.79,5.06A9.46,9.46,0,0,1,36.61,236.76Zm15.6-18.36c-.31,4.73-.57,13.5-1.87,16a5.77,5.77,0,0,1-3.7,3.11,5.17,5.17,0,0,1-3.81-.49c1.32-2.78,2-4.14,3.45-6.8a1.35,1.35,0,0,0-.33-1.63.88.88,0,0,0-1.38.27c-1.47,2.66-2.17,4-3.51,6.81a8.55,8.55,0,0,1-1.33-9.66C41.17,223.51,48.25,220,52.21,218.4Zm-1.33-17.23c-.86,4.62-2.15,13.23-3.74,15.58a5.86,5.86,0,0,1-4,2.63,5.26,5.26,0,0,1-3.72-.9c1.64-2.59,2.48-3.85,4.22-6.3a1.31,1.31,0,0,0-.14-1.65.88.88,0,0,0-1.4.1c-1.76,2.46-2.62,3.72-4.28,6.31a8.41,8.41,0,0,1-.18-9.66C39.33,204.93,46.76,202.31,50.88,201.17ZM51.54,184c-1.38,4.49-3.66,12.84-5.51,15a5.89,5.89,0,0,1-4.31,2.14,5.29,5.29,0,0,1-3.59-1.33c1.92-2.37,2.91-3.51,4.92-5.74a1.31,1.31,0,0,0,.05-1.64.89.89,0,0,0-1.41,0c-2,2.22-3,3.36-5,5.73a8.35,8.35,0,0,1,.93-9.56C39.63,186.38,47.32,184.64,51.54,184ZM54.16,167c-1.89,4.28-5.11,12.31-7.18,14.2a5.88,5.88,0,0,1-4.54,1.64A5.3,5.3,0,0,1,39,181.14C41.21,179,42.32,178,44.57,176a1.32,1.32,0,0,0,.25-1.63.91.91,0,0,0-1.4-.21c-2.27,2-3.39,3-5.6,5.11a8,8,0,0,1-.59-4.46,7.93,7.93,0,0,1,2.61-4.91C42.05,168,49.89,167.19,54.16,167Zm4.53-16.53c-2.36,4-6.47,11.63-8.75,13.28a5.85,5.85,0,0,1-4.69,1.09,5.32,5.32,0,0,1-3.2-2.09c2.41-1.86,3.63-2.75,6.09-4.46a1.3,1.3,0,0,0,.43-1.58.9.9,0,0,0-1.36-.37c-2.48,1.69-3.71,2.58-6.15,4.43a8.29,8.29,0,0,1,3.08-9.08C46.55,150.11,54.43,150.17,58.69,150.5Zm-3.82-3.72a5.83,5.83,0,0,1-4.78.54,5.29,5.29,0,0,1-2.94-2.46c2.61-1.57,3.92-2.31,6.56-3.72a1.31,1.31,0,0,0,.61-1.53.9.9,0,0,0-1.31-.52c-2.66,1.4-4,2.14-6.62,3.7a8.18,8.18,0,0,1,.44-4.48,7.93,7.93,0,0,1,3.66-4.2c2.59-1.34,10.41-.39,14.61.43C62.28,138.3,57.32,145.4,54.87,146.78Z"
                className="Badge__SecondFillColor"
              />
              <path
                d="M84.14,79.84a1.17,1.17,0,0,0,1.6-.17A137.67,137.67,0,0,1,109.3,60.83a1,1,0,1,0-1.1-1.67A140.2,140.2,0,0,0,84.36,78.23,1.16,1.16,0,0,0,84.14,79.84Z"
                className="Badge__SecondFillColor"
              />
              <path
                d="M75.41,81.12A1.17,1.17,0,0,0,77,80.86a254.28,254.28,0,0,1,29.34-24.48,1.05,1.05,0,1,0-1.11-1.67A257.5,257.5,0,0,0,75.59,79.49,1.17,1.17,0,0,0,75.41,81.12Z"
                className="Badge__SecondFillColor"
              />
              <path
                d="M60.22,90.42A1.21,1.21,0,0,0,61.83,90a175.18,175.18,0,0,1,41.48-38.22c.64-.43.93-1.14.63-1.61a1.26,1.26,0,0,0-1.73-.06,177.79,177.79,0,0,0-42,38.66A1.21,1.21,0,0,0,60.22,90.42Z"
                className="Badge__SecondFillColor"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M241.35,137.79h-82.7l8.83-32.1h65Zm-79.63-2.34h76.56L230.73,108H169.27Z"
                className="Badge__SecondFillColor"
              />
              <path
                d="M173.1,220.55H173a1.17,1.17,0,0,1-1.08-1.25L178,136.53a1.17,1.17,0,0,1,1.25-1.08,1.18,1.18,0,0,1,1.09,1.26l-6.09,82.76A1.17,1.17,0,0,1,173.1,220.55Z"
                className="Badge__SecondFillColor"
              />
              <path
                d="M226.9,220.55a1.18,1.18,0,0,1-1.17-1.08l-6.08-82.77a1.17,1.17,0,0,1,1.08-1.25,1.19,1.19,0,0,1,1.26,1.08l6.08,82.77a1.17,1.17,0,0,1-1.08,1.25Z"
                className="Badge__SecondFillColor"
              />
              <path
                d="M205.38,219a1.17,1.17,0,0,1-1.17-1.17V196.21h-8.42v21.64a1.17,1.17,0,0,1-2.34,0V195a1.17,1.17,0,0,1,1.17-1.17h10.76a1.17,1.17,0,0,1,1.17,1.17v22.81A1.17,1.17,0,0,1,205.38,219Z"
                className="Badge__SecondFillColor"
              />
            </g>
            <g>
              <g>
                <g>
                  <polygon
                    points="165.55 196.94 147.72 174.51 195.98 133.75 204.32 142.79 165.55 196.94"
                    className="Badge__SecondFillColor"
                  />
                  <g>
                    <g>
                      <polygon
                        points="159.17 180.3 154.58 174.6 164.83 165.22 168.88 170.09 159.17 180.3"
                        className="Badge__FirstFillColor"
                      />
                      <polygon
                        points="165.89 188.65 161.18 182.8 170.65 172.22 174.79 177.19 165.89 188.65"
                        className="Badge__FirstFillColor"
                      />
                    </g>
                    <g>
                      <polygon
                        points="171.71 167.12 167.81 162.48 175.01 155.9 178.5 159.97 171.71 167.12"
                        className="Badge__FirstFillColor"
                      />
                      <polygon
                        points="177.37 173.87 173.4 169.14 180.03 161.74 183.59 165.88 177.37 173.87"
                        className="Badge__FirstFillColor"
                      />
                    </g>
                    <g>
                      <polygon
                        points="180.54 157.82 177.17 153.92 182.5 149.04 185.57 152.53 180.54 157.82"
                        className="Badge__FirstFillColor"
                      />
                      <polygon
                        points="185.44 163.49 182.01 159.52 186.9 154.06 190.02 157.6 185.44 163.49"
                        className="Badge__FirstFillColor"
                      />
                    </g>
                    <g>
                      <polygon
                        points="187.11 150.91 184.13 147.55 188.23 143.79 190.97 146.85 187.11 150.91"
                        className="Badge__FirstFillColor"
                      />
                      <polygon
                        points="191.43 155.79 188.4 152.38 192.16 148.18 194.94 151.27 191.43 155.79"
                        className="Badge__FirstFillColor"
                      />
                    </g>
                  </g>
                </g>
                <g>
                  <polygon
                    points="229.09 88.9 246.94 105.91 204.07 143.06 195.74 134.01 229.09 88.9"
                    className="Badge__SecondFillColor"
                  />
                  <g>
                    <g>
                      <polygon
                        points="236.07 101.32 240.78 105.84 232.44 113.61 228.3 109.52 236.07 101.32"
                        className="Badge__FirstFillColor"
                      />
                      <polygon
                        points="229.46 94.95 234.06 99.38 226.53 107.77 222.47 103.77 229.46 94.95"
                        className="Badge__FirstFillColor"
                      />
                    </g>
                    <g>
                      <polygon
                        points="225.95 112 229.92 115.95 223.69 121.75 220.13 118.14 225.95 112"
                        className="Badge__FirstFillColor"
                      />
                      <polygon
                        points="220.35 106.43 224.25 110.31 218.6 116.6 215.11 113.05 220.35 106.43"
                        className="Badge__FirstFillColor"
                      />
                    </g>
                    <g>
                      <polygon
                        points="218.34 120.04 221.77 123.54 216.93 128.04 213.82 124.81 218.34 120.04"
                        className="Badge__FirstFillColor"
                      />
                      <polygon
                        points="213.49 115.09 216.87 118.54 212.48 123.42 209.41 120.24 213.49 115.09"
                        className="Badge__FirstFillColor"
                      />
                    </g>
                    <g>
                      <polygon
                        points="212.4 126.3 215.42 129.45 211.57 133.04 208.79 130.11 212.4 126.3"
                        className="Badge__FirstFillColor"
                      />
                      <polygon
                        points="208.13 121.85 211.11 124.95 207.6 128.86 204.86 125.97 208.13 121.85"
                        className="Badge__FirstFillColor"
                      />
                    </g>
                  </g>
                </g>
                <g>
                  <polygon
                    points="153.05 105.91 170.91 88.9 204.26 134.01 195.92 143.06 153.05 105.91"
                    className="Badge__SecondFillColor"
                  />
                  <g>
                    <g>
                      <polygon
                        points="165.94 99.38 170.54 94.95 177.53 103.76 173.47 107.78 165.94 99.38"
                        className="Badge__FirstFillColor"
                      />
                      <polygon
                        points="159.22 105.84 163.92 101.32 171.7 109.52 167.56 113.61 159.22 105.84"
                        className="Badge__FirstFillColor"
                      />
                    </g>
                    <g>
                      <polygon
                        points="175.75 110.31 179.64 106.43 184.89 113.05 181.39 116.6 175.75 110.31"
                        className="Badge__FirstFillColor"
                      />
                      <polygon
                        points="170.08 115.95 174.05 112 179.87 118.14 176.31 121.75 170.08 115.95"
                        className="Badge__FirstFillColor"
                      />
                    </g>
                    <g>
                      <polygon
                        points="183.13 118.54 186.51 115.09 190.59 120.24 187.52 123.42 183.13 118.54"
                        className="Badge__FirstFillColor"
                      />
                      <polygon
                        points="178.23 123.54 181.66 120.04 186.18 124.81 183.06 128.04 178.23 123.54"
                        className="Badge__FirstFillColor"
                      />
                    </g>
                    <g>
                      <polygon
                        points="188.89 124.95 191.87 121.85 195.14 125.97 192.4 128.86 188.89 124.95"
                        className="Badge__FirstFillColor"
                      />
                      <polygon
                        points="184.57 129.45 187.6 126.3 191.21 130.11 188.43 133.04 184.57 129.45"
                        className="Badge__FirstFillColor"
                      />
                    </g>
                  </g>
                </g>
                <g>
                  <polygon
                    points="252.27 174.51 234.44 196.94 195.68 142.79 204.01 133.75 252.27 174.51"
                    className="Badge__SecondFillColor"
                  />
                  <g>
                    <g>
                      <polygon
                        points="238.82 182.8 234.11 188.65 225.21 177.19 229.35 172.22 238.82 182.8"
                        className="Badge__FirstFillColor"
                      />
                      <polygon
                        points="245.42 174.6 240.82 180.3 231.12 170.09 235.17 165.22 245.42 174.6"
                        className="Badge__FirstFillColor"
                      />
                    </g>
                    <g>
                      <polygon
                        points="226.59 169.14 222.62 173.87 216.41 165.88 219.97 161.74 226.59 169.14"
                        className="Badge__FirstFillColor"
                      />
                      <polygon
                        points="232.19 162.48 228.29 167.12 221.5 159.97 224.99 155.9 232.19 162.48"
                        className="Badge__FirstFillColor"
                      />
                    </g>
                    <g>
                      <polygon
                        points="217.99 159.52 214.55 163.49 209.97 157.6 213.09 154.05 217.99 159.52"
                        className="Badge__FirstFillColor"
                      />
                      <polygon
                        points="222.83 153.92 219.46 157.82 214.43 152.53 217.5 149.04 222.83 153.92"
                        className="Badge__FirstFillColor"
                      />
                    </g>
                    <g>
                      <polygon
                        points="211.59 152.38 208.57 155.79 205.06 151.27 207.83 148.18 211.59 152.38"
                        className="Badge__FirstFillColor"
                      />
                      <polygon
                        points="215.87 147.55 212.89 150.91 209.02 146.85 211.76 143.79 215.87 147.55"
                        className="Badge__FirstFillColor"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <path
                d="M202.79,141.39a3.7,3.7,0,0,1-5.58,0,4.52,4.52,0,0,1,0-6,3.72,3.72,0,0,1,5.53,0A4.51,4.51,0,0,1,202.79,141.39Z"
                className="Badge__FirstFillColor"
              />
              <path
                d="M200,145.79a6.54,6.54,0,0,1-4.88-2.21,7.79,7.79,0,0,1,.07-10.36,6.48,6.48,0,0,1,9.61,0,7.78,7.78,0,0,1,.08,10.36A6.54,6.54,0,0,1,200,145.79Zm0-13.52a5.38,5.38,0,0,0-3.95,1.75,6.57,6.57,0,0,0-.06,8.77,5.31,5.31,0,0,0,8,0A6.6,6.6,0,0,0,204,134,5.4,5.4,0,0,0,200,132.27Z"
                className="Badge__FirstFillColor"
              />
            </g>
          </g>
          <g id="_Gruppe_" data-name="<Gruppe>">
            <path
              d="M240.73,223.31l.06-.13c17.9,0,39.69,17,39.69,26.75s-7.12,28-75.28,28-85.68-13.59-85.68-27.39c0-10.36,6.74-18.51,14.71-18.51,0,0,11-7.38,24.38-7.38a35.54,35.54,0,0,1,3.89.2h0a33.33,33.33,0,0,1,17-4.94,33.75,33.75,0,0,1,9,1.28v0A44.34,44.34,0,0,1,203,218.28a31.3,31.3,0,0,1,10.85,2.11l.05-.14S225.12,216.32,240.73,223.31Z"
              className="Badge__FirstFillColor"
            />
            <g>
              <path
                d="M205.2,279.14c-57.63,0-86.86-9.61-86.86-28.56,0-10.85,7.13-19.68,15.89-19.68,25.82,0,41.41,26.15,41.57,26.42a1.17,1.17,0,1,1-2,1.18c-.15-.25-15.08-25.26-39.55-25.26-7.47,0-13.54,7.78-13.54,17.34,0,12,14.66,26.22,84.51,26.22,61.25,0,74.11-14.61,74.11-26.87,0-8.67-20.8-25.58-38.52-25.58a1.17,1.17,0,0,1,0-2.34c8.43,0,18.36,3.63,27.24,10,8.4,6,13.62,12.87,13.62,18C281.65,274.07,240.08,279.14,205.2,279.14Z"
                className="Badge__SecondFillColor"
              />
              <path
                d="M203,257.49a1.18,1.18,0,0,1-1-.49l-1.23-1.78c-6.08-8.79-18.73-27.08-38.38-29.17a1.17,1.17,0,0,1-1-1.29,1.19,1.19,0,0,1,1.29-1c20.72,2.21,33.78,21.09,40.05,30.17l1.23,1.76a1.17,1.17,0,0,1-.29,1.63A1.11,1.11,0,0,1,203,257.49Z"
                className="Badge__SecondFillColor"
              />
              <path
                d="M134.23,233.24a1.17,1.17,0,0,1-.65-2.14c.46-.31,11.45-7.59,25-7.59a37.9,37.9,0,0,1,4,.21,1.17,1.17,0,0,1-.24,2.33,36,36,0,0,0-3.77-.19c-12.85,0-23.62,7.11-23.72,7.18A1.14,1.14,0,0,1,134.23,233.24Z"
                className="Badge__SecondFillColor"
              />
              <path
                d="M232.81,257.4a1.17,1.17,0,0,1-.81-.33c-2-1.92-4.23-4.28-6.6-6.79-9.5-10-22.52-23.77-37.18-27.92a30.77,30.77,0,0,0-25,3.49,1.19,1.19,0,0,1-.51.2,1.17,1.17,0,0,1-1-2h0a1.1,1.1,0,0,1,.28-.2,33,33,0,0,1,26.88-3.73c15.29,4.32,28.56,18.33,38.25,28.56,2.35,2.49,4.58,4.83,6.53,6.71a1.18,1.18,0,0,1,0,1.66A1.15,1.15,0,0,1,232.81,257.4Z"
                className="Badge__SecondFillColor"
              />
              <path
                d="M254.81,257.4a1.15,1.15,0,0,1-1-.5c-.2-.28-19.53-27.67-40.45-35.41a30.17,30.17,0,0,0-10.44-2,43.32,43.32,0,0,0-14,2.83,1.17,1.17,0,0,1-1.52-.65,1.16,1.16,0,0,1,.64-1.52,44.89,44.89,0,0,1,14.85-3,32.43,32.43,0,0,1,11.26,2.18c9.09,3.36,18.85,10.5,29,21.2a146.54,146.54,0,0,1,12.55,15.07,1.17,1.17,0,0,1-.29,1.63A1.2,1.2,0,0,1,254.81,257.4Z"
                className="Badge__SecondFillColor"
              />
              <path
                d="M271.85,251.75a1.17,1.17,0,0,1-1-.49c-9.44-13-19.75-22-30.65-26.88-15-6.73-25.89-3.06-26-3a1.17,1.17,0,0,1-1.49-.72,1.16,1.16,0,0,1,.72-1.49c.47-.17,11.87-4,27.73,3.1,11.28,5,21.9,14.32,31.58,27.64a1.16,1.16,0,0,1-.25,1.63A1.19,1.19,0,0,1,271.85,251.75Z"
                className="Badge__SecondFillColor"
              />
            </g>
          </g>
        </g>
      </g>

      {/* ------------------------------------------ */}

      <g className="TEXT">

        <text
          x=""
          y=""
          dy=".7ex"
          textAnchor="middle"
          fontFamily="Bitter"
          fontSize="2.2em"
          fontWeight="700"
          letterSpacing="0.15em"
          className="Badge__SecondFillColor"
        >
          <textPath xlinkHref="#RadialBadge_10__TopCircle" startOffset="50%">
            {line2.toUpperCase()}
          </textPath>
        </text>

        <text
          x=""
          y=""
          dy=".79ex"
          textAnchor="middle"
          fontFamily="Abel"
          fontSize="1.8em"
          letterSpacing="0.05em"
          className="Badge__SecondFillColor"
        >
          <textPath xlinkHref="#RadialBadge_10__BottomCircle" startOffset="50%">
            {line3.toUpperCase()} {line4.toUpperCase()}
          </textPath>
        </text>

      </g>

    </svg>
  );
}

export default Badge;
